<template>
  <div>
    <div class="back-img"/>
    <div class="opacity"/>
    <TopMenu
      no-menu
      no-background/>
    <div class="logo">
      <a
        href="http://sqc.ca"
        target="_blank"><img
          src="../../assets/images/SQC_logo_signature_white.svg"
          alt="Syndicat Québécois Construction"
          width="150" ></a>
    </div>
    <div class="forgot-password text-center">
      <form
        class="form-forgot-password"
        @submit.prevent="submit">
        <p class="baseColor">{{ $t("FORGOT_PASSWORD.INSTRUCTION_TEXT") }}</p>
        <label
          for="inputEmail"
          class="sr-only">{{ $t("FORGOT_PASSWORD.EMAIL_ADDRESS_PLACEHOLDER") }}</label>
        <input
          id="inputEmail"
          v-model="email"
          :placeholder="$t('FORGOT_PASSWORD.EMAIL_ADDRESS_PLACEHOLDER')"
          type="email"
          class="form-control"
          required
          autofocus>
        <ActionButton
          type="submit"
          class-name="btn btn-lg btn-secondary btn-block mt-3">{{ $t("FORGOT_PASSWORD.SEND_BUTTON_TEXT") }}</ActionButton>
        <LanguagePicker/>
        <Copyright/>
      </form>
    </div>
  </div>
</template>

<script>
import TopMenu from '@/components/Menu/TopMenu';
import TextLink from '@/components/Utils/TextLink';
import ActionButton from '@/components/Actions/ActionButton';
import LanguagePicker from '@/components/Utils/LanguagePicker';
import Copyright from '@/components/Utils/Copyright';

export default {
  name: 'ForgotPassword',
  components: {
    ActionButton,
    Copyright,
    LanguagePicker,
    TextLink,
    TopMenu,
  },
  data() {
    return {
      email: '',
    };
  },
  methods: {
    submit() {
      this.$store.dispatch('user/forgotPassword', {
        email: this.email,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.back-img {
  background-image: url("../../assets/images/background_image_login.jpg");
  background-size: cover;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
  background-position: center;
}
.opacity {
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  top: 0;
  z-index: -1;
}
div {
  &.forgot-password {
    min-height: 100%;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: center;
    -ms-flex-pack: center;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
.logo {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  background-color: $primary;
  width: 175px;
  margin-left: auto;
  margin-right: auto;
}
.form-forgot-password {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.form-forgot-password .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 20px;
}
.form-forgot-password .form-control:focus {
  z-index: 2;
}
.form-forgot-password input[type="email"] {
  margin-bottom: 10px;
}
</style>
